import { TABLE_IDS } from '@cards/engine';
import { cardRef, defineGameCard, onDeath } from '../authoring/index.js';
import { createFragmentInLocation, fragmentCount, locationHasSpace, ownerSide } from './helpers.js';
export const ScrapTransporterCard = defineGameCard({
    id: 'scrap_transporter',
    gameplay: {
        type: 'UNIT', cost: 4,
        baseStats: { attack: 4, health: 5 },
    },
    presentation: {
        name: 'Транспортёр лома',
        description: 'Распад 2: создаёт до 2 Фрагментов в разных локациях. Сначала создаёт их там, где уже есть ваш Фрагмент.',
        glyph: {
            colors: ['#10213A', '#484850', '#595A61', '#2B242E', '#AD7641'],
            rows: [
                '........1111........',
                '.......122221.......',
                '.......122331.......',
                '...111.122221.111...',
                '..1333111422112331..',
                '.122213321122213321.',
                '.122213321132212221.',
                '.111142355552441141.',
                '.11414435555121111..',
                '.124..115555111.124.',
                '.111.121255221..123.',
                '1331..42211224...22.',
                '1321...1444411...12.',
                '.11141..1442.....121',
                '....131.1111.21.....',
                '22..1221....1231.31.',
                '11..1221....1231.11.',
                '...1.21.....1211.1..',
                '....1221...142221...',
                '....1111...111111...',
            ],
        },
    },
    role: 'playable',
    dependencies: [cardRef('fragment'), cardRef('reconstructed_robot')],
    abilities: [
        onDeath((ctx) => {
            const self = ctx.self;
            const side = ownerSide(ctx, self.controllerId);
            const targets = TABLE_IDS
                .filter((tableId) => locationHasSpace(ctx, tableId, side))
                .sort((a, b) => {
                const aHasFragment = fragmentCount(ctx, self.controllerId, a) > 0 ? 1 : 0;
                const bHasFragment = fragmentCount(ctx, self.controllerId, b) > 0 ? 1 : 0;
                return bHasFragment - aHasFragment || a - b;
            });
            let created = 0;
            for (const tableId of targets) {
                if (createFragmentInLocation(ctx, self.controllerId, tableId).created !== null)
                    created += 1;
                if (created === 2)
                    break;
            }
        }),
    ],
    ui: { mechanics: ['decay', 'fragment'] },
});
//# sourceMappingURL=scrap-transporter.js.map